import { useRender } from "../../context/renderContext";
import GlassCard from "../ui/GlassCard";
const formatInsights = (rawText) => {
  if (!rawText) {
    return `No insights are available yet.

This usually means there isn't enough data to generate meaningful insights at the moment. Once more information is collected, personalized insights and recommended action steps will appear here.`;
  }
  return rawText
    .replace(
      /\*\*Insights:\*\*/g,
      "<h2 class='font-semibold text-lg mb-2 text-slate-900 dark:text-white'>Insights</h2>",
    )
    .replace(
      /\*\*Actionable Steps:\*\*/g,
      "<h2 class='font-semibold text-lg mt-4 mb-2 text-slate-900 dark:text-white'>Actionable Steps</h2>",
    )
    .replace(
      /\d+\.\s\*\*(.*?)\*\*/g,
      "<p class='font-semibold mt-3 text-[#6D5AE0] dark:text-[#8C7CF0]'>$1</p>",
    )
    .replace(
      /-\s\*\*(.*?)\*\*/g,
      "<li class='ml-4 list-disc marker:text-[#F0498C]'><strong>$1</strong>",
    )
    .replace(
      /\*\*(.*?)\*\*/g,
      "<strong class='text-slate-900 dark:text-white'>$1</strong>",
    );
};
const PulseTrace = () => (
  <div className="flex flex-col items-center justify-center h-full min-h-[180px] gap-3">
    <svg viewBox="0 0 200 40" className="w-40 h-10">
      <polyline
        points="0,20 40,20 55,4 70,36 85,20 200,20"
        fill="none"
        stroke="#8C7CF0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="220"
        strokeDashoffset="220"
        className="animate-[pulsetrace_1.6s_ease-in-out_infinite]"
      />
      <style>{`
        @keyframes pulsetrace {
          0% { stroke-dashoffset: 220; opacity: .3; }
          50% { stroke-dashoffset: 0; opacity: 1; }
          100% { stroke-dashoffset: -220; opacity: .3; }
        }
      `}</style>
    </svg>
    <p className="text-xs text-slate-400 dark:text-white/40 tracking-wide">
      Reading the signals…
    </p>
  </div>
);
const KeyInsights = () => {
  const { renderText } = useRender();
  const rawText = renderText?.();
  const html = formatInsights(rawText);
  return (
    <GlassCard
      accent="violet"
      className="flex flex-col text-slate-900 dark:text-white"
    >
      <h1 className="font-['Space_Grotesk',_sans-serif] text-[22px] font-semibold mb-1">
        Based on the identified issues, here are some key insights
      </h1>
      <div className="overflow-auto min-h-[200px] mt-2">
        {rawText === undefined ? (
          <PulseTrace />
        ) : rawText === null ? (
          <div className="flex min-h-[350px] items-center justify-center">
            <div className="text-center">
              <h3 className="text-xl font-semibold text-white">
                No insights available yet
              </h3>
              <p className="mt-2 max-w-md text-sm text-slate-400">
                There isn't enough conversation data for the selected date range
                to generate meaningful insights.
              </p>
            </div>
          </div>
        ) : (
          <div
            className="text-slate-600 dark:text-white/70 leading-relaxed text-sm space-y-1"
            dangerouslySetInnerHTML={{ __html: html || "" }}
          />
        )}
      </div>
    </GlassCard>
  );
};
var KeyInsights_default = KeyInsights;
export { KeyInsights_default as default };
